import { render } from "./TokenSelector.vue?vue&type=template&id=2672e89d"
import script from "./TokenSelector.vue?vue&type=script&lang=js"
export * from "./TokenSelector.vue?vue&type=script&lang=js"

import "./TokenSelector.vue?vue&type=style&index=0&id=2672e89d&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TokenSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2672e89d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2672e89d', __exports__)) {
    api.reload('2672e89d', __exports__)
  }
  
  module.hot.accept("./TokenSelector.vue?vue&type=template&id=2672e89d", () => {
    api.rerender('2672e89d', render)
  })

}


export default __exports__